export const studentConferencesConstants = {
  LOAD: "SCC_LOAD",
  RESET: "SCC_RESET",
};
